<template>
  <div class="docs">
    <div class="docs__card">
      <div class="docs__title text-w4">
        API文档
      </div>
      <div class="flex docs__main">
        <div class="common__submenu docs__submenu">
            <!-- <router-link to="/document/dermx82">
                <div :class="'common__submenu__item ' + (doc === 'dermx82' ? 'selected' : '')">体素肤知汇基础版</div>
            </router-link> -->
            <router-link to="/document/dermx152">
                <div :class="'common__submenu__item ' + (doc === 'dermx152' ? 'selected' : '')">体素肤知汇进阶版</div>
            </router-link>
            <router-link to="/document/derms">
                <div :class="'common__submenu__item ' + (doc === 'derms' ? 'selected' : '')">体素肤美汇</div>
            </router-link>
            <!-- <router-link to="/document/api">
                <div :class="'common__submenu__item ' + (doc === 'api' ? 'selected' : '')">API</div>
            </router-link> -->
        </div>
        <div class="docs__body">
          <iframe ref="docsify" v-if="url" :src="url" width="100%" height="100%"></iframe>
          <div v-else style="margin: 32px 0 0 16px; font-size: 31px; font-weight: 600">文档即将上线...</div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
const API_FILENAME_MAPPING = {
  dermx82: 'Voxelcloud_DermX82_API_Document',
  derms: 'Voxelcloud_DermS_API_Document',
  dermx152: 'Voxelcloud_DermX152_API_Document',
}
export default {
  name: 'docs',
  props: {
    doc: {
      type: String,
      default: 'dermx152',
    }
  },
  computed: {
    url() {
      const docName = API_FILENAME_MAPPING[this.doc];
      if (!docName)
        return '';
      return `${origin}/docs/#/${docName}`;
    },
  },
  updated() {
    let iframeDocument = this.$refs.docsify.contentDocument || this.$refs.docsify.contentWindow.document;
    let body = iframeDocument.getElementsByTagName('body')[0];
    body.insertAdjacentHTML('beforeend', '<aside class="sidebar"></aside>');
    body.insertAdjacentHTML('beforeend', '<button class="sidebar-toggle"></button>');
  }
};
</script>

<style lang="less">
    @prefix: ~'docs';
    .@{prefix} {
        background: #ECEFF1;
        &__card {
        width: 1008px;
        margin: -8px auto 0 auto;
        // padding-bottom: 64px;
        border-radius: 8px;
        background: white;
        box-shadow: 0 2px 4px 0 rgba(black, 0.1), 0 3px 4px 0 rgba(black, 0.08), 0 1px 5px 0 rgba(black, 0.16);
        }
        &__title {
            font-size: 31px;
            line-height: 48px;
            letter-spacing: -0.86;
            color: rgba(black, 0.54);
            width: 100%;
            padding: 20px 0 11px 16px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        }
        &__body {
          border-left: 1px solid rgba(black, 0.08);
          flex-grow: 1;
          height: calc(100vh - 168px);
        }
    }

    @media only screen and (max-width: 768px) {
    .@{prefix} {
        &__card {
            width: 100vw;
            background: white;
            box-shadow: none;
            margin-top: -48px;
            padding-top: 20px;
        }

        &__title {
            font-size: 21px;
            line-height: 28px;
            padding: 0 0 30px 16px;
            border-bottom: none;
        }

        &__main {
            height: auto;
            flex-direction: column;
        }

        &__submenu {
            padding: 0;
            background: white;
            max-width: 100vw;
            width: auto;
            display: flex;
            flex-direction: row;

            & .common__submenu__item {
                margin-bottom: 0;
                padding: 10px 16px;
                text-align: center;
                width: 50vw;
                background: white;

                border-bottom: 1px solid rgba(black, 0.08);

                &.selected {
                    color: @primary-color;
                    border-bottom: 2px solid @primary-color;
                }
            }
        }
    }
    }
</style>
